import { AlertTriangle } from "lucide-react";
import { Button } from "../components/ui/Button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/Card";

export const CheckoutCancel = () => {
  return (
    <div className="max-w-2xl mx-auto space-y-8">
      {/* Cancel Header */}
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-orange-600" />
          </div>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Checkout Cancelled
        </h1>
        <p className="text-gray-600 text-lg">
          Your checkout process was cancelled. No payment has been processed.
        </p>
      </div>

      {/* Information Card */}
      <Card>
        <CardHeader>
          <CardTitle>What happened?</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <p className="text-gray-600">
              You cancelled the checkout process before completing your payment.
              Your basket items are still saved and you can continue your
              booking at any time.
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h3 className="font-medium text-blue-900 mb-2">
                Your basket is safe
              </h3>
              <p className="text-sm text-blue-800">
                All your selected events and participant details are still in
                your basket. You can return to complete your booking whenever
                you're ready.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Next Steps */}
      <Card>
        <CardHeader>
          <CardTitle>What would you like to do?</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-xs font-semibold text-primary-600">
                  1
                </span>
              </div>
              <div>
                <p className="font-medium">Return to your basket</p>
                <p className="text-sm text-gray-600">
                  Review your selected events and continue with checkout.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-xs font-semibold text-primary-600">
                  2
                </span>
              </div>
              <div>
                <p className="font-medium">Browse more events</p>
                <p className="text-sm text-gray-600">
                  Add additional events to your basket before checking out.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-xs font-semibold text-primary-600">
                  3
                </span>
              </div>
              <div>
                <p className="font-medium">Start over</p>
                <p className="text-sm text-gray-600">
                  Clear your basket and begin a new booking from scratch.
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Actions */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Button asChild>
          <a href="/basket">Return to Basket</a>
        </Button>
        <Button variant="outline" asChild>
          <a href="/events">Browse Events</a>
        </Button>
      </div>
    </div>
  );
};
